exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxt-table td.gwnl-evaluator__td{padding:0}\n", ""]);

